import React from "react";
import {
  Typography,
  Box,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import SpecificHandlingXs from "./small-ui/SpecificHandlingXs";

const SpecificHandling = ({ id, isXs }) => {
  const { t } = useTranslation();

  if (isXs) return <SpecificHandlingXs id={id} />; // Return null for mobile view

  return (
    <Paper elevation={1} sx={{ p: 4, mb: 4 }} id={id}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
        <i className="fas fa-cog fa-2x" style={{ color: "#0c4d96" }}></i>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ ml: 2, color: "#0c4d96" }}
        >
          {t("privacy-policy.specific-handling.title")}
        </Typography>
      </Box>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        {t("privacy-policy.specific-handling.usage.title")}
      </Typography>
      <List>
        {t("privacy-policy.specific-handling.usage.purposes", {
          returnObjects: true,
        }).map((purpose, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <i
                className="fas fa-chevron-right"
                style={{ color: "#0c4d96" }}
              ></i>
            </ListItemIcon>
            <ListItemText primary={purpose} />
          </ListItem>
        ))}
      </List>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, mt: 3 }}>
        {t("privacy-policy.specific-handling.scope.title")}
      </Typography>
      <List>
        {t("privacy-policy.specific-handling.scope.items", {
          returnObjects: true,
        }).map((item, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <i
                className="fas fa-chevron-right"
                style={{ color: "#0c4d96" }}
              ></i>
            </ListItemIcon>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, mt: 3 }}>
        {t("privacy-policy.specific-handling.outsourcing.title")}
      </Typography>

      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1, mt: 3 }}>
        {t("privacy-policy.specific-handling.retention.title")}
      </Typography>
    </Paper>
  );
};

export default SpecificHandling;
